import { Tooltip } from 'antd';
import Scorecard from 'components/atoms/Scorecard';
import Loader from 'components/molecules/Loader';
import { colorConstants } from 'config/colorConstants';
import _ from 'lodash';
import { renderTitle } from './getSalesAttributionColumns';
import { calculateFontSize, formatNumWithKMBAlt } from './helperMethods';
import UpAltSvg from 'assets/svg/UpAlt';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import DownSvg from 'assets/svg/Down';
import { trackEventMixpanel } from './mixpanel';
import { PROMO_SCORECARD_QUESTION_ROW_EXPANDED } from './mixpanelEventNames';
export const getScorecardQuestionsColumns = (
    data: any,
    onClick: Function,
    promoTypeLength: any,
    expandedIndex: null | number,
    setExpandedIndex: Function,
    selectedAttributeName: string,
    questionObj: any,
    showGradientTile: boolean,
) => {
    const result: any = [];
    const keysArray = Array.isArray(data) ? Object.keys(data[0]) : [];
    const colSpan = (idx: number, loading = false) => {
        if (idx === 0) {
            return 4;
        }
        if (loading) {
            if (idx == 2) {
                return promoTypeLength;
            }
            return 0;
        }
        return 1;
    };
    keysArray.slice(0, keysArray.length - 1).map((key, idx) => {
        if (key == 'loading') return;
        const isLastItem = idx === keysArray.length - 2;
        const temp = {
            title: renderTitle(
                idx === 1 ? selectedAttributeName || '' : isLastItem ? '' : key,
                idx === 0 ? null : undefined,
                undefined,
                'text-purpleFont !font-medium',
                graphXAxisLabelFontSize,
            ),
            dataIndex: key,
            width: idx === 0 ? 350 : isLastItem ? 40 : 120,
            key: key,
            //  colSpan: colSpan(idx),
            onCell: (record: any, index: number) => {
                //only enable onclick for questions
                const hideNestedData = record['nestedIndex'] !== null && record['nestedIndex'] !== expandedIndex;
                const clickHandler = {
                    onClick: () => {
                        if (record['nestedIndex'] === null) onClick(record, index);
                        if (!(record && record.isExpandable)) return;
                        if (expandedIndex === index) setExpandedIndex(null);
                        else {
                            trackEventMixpanel(PROMO_SCORECARD_QUESTION_ROW_EXPANDED, {
                                rowName: record?.Questions,
                            });
                            setExpandedIndex(index);
                        }
                    },
                };

                return {
                    ...clickHandler,
                    // colSpan: colSpan(idx, record.loading),
                    colSpan: hideNestedData ? 0 : 1,
                    style: {
                        cursor: record['nestedIndex'] === null ? 'pointer' : 'auto',
                        backgroundColor:
                            expandedIndex !== null &&
                            (record['nestedIndex'] === expandedIndex || index === expandedIndex)
                                ? colorConstants.lightPurple
                                : questionObj?.QuestionIndex === record?.QuestionIndex
                                ? colorConstants.greyAlt1
                                : 'white',
                    },
                };
            },
            align: idx === 0 ? 'left' : 'center',
            fixed: idx === 0 ? 'left' : false,

            render: (columnData: any, rowData: any, rowIndex: number) => {
                const hideNestedData = rowData['nestedIndex'] !== null && rowData['nestedIndex'] !== expandedIndex;
                const color = rowData['color'][key];
                const className = key === keysArray[0] ? 'text-subHeaderColor font-xs' : 'flex justify-center';
                if (rowData.loading && idx == 3) return <Loader />; //show loader in the middle
                if (rowData.error && idx == 3) return <div>No Data</div>; // show no data in case of error

                //dropdown and if expanded is true show arrow
                if (isLastItem && columnData) {
                    return (
                        <span
                            onClick={() => {
                                //resetting
                                if (expandedIndex === rowIndex) setExpandedIndex(null);
                                else {
                                    trackEventMixpanel(PROMO_SCORECARD_QUESTION_ROW_EXPANDED, {
                                        rowName: rowData?.Questions,
                                    });
                                    setExpandedIndex(rowIndex);
                                }
                            }}
                            className={`${className} cursor-pointer`}
                        >
                            {expandedIndex === rowIndex ? <UpAltSvg /> : <DownSvg />}
                        </span>
                    );
                }
                if (!hideNestedData) {
                    const tooltip = rowData['tooltip'] || null;
                    return (
                        <div className={className}>
                            {key === keysArray[0] ? (
                                <Tooltip
                                    trigger={'hover'}
                                    placement="top"
                                    color="white"
                                    overlayStyle={{ borderRadius: 4 }}
                                    overlayInnerStyle={{
                                        color: colorConstants.darkGrey,
                                    }}
                                    title={tooltip}
                                >
                                    <p className="font-sm">
                                        {rowData['Questions']}
                                        <i className="font-light">{rowData['italicsUnits']} </i>
                                    </p>
                                </Tooltip>
                            ) : idx === 1 ? (
                                <div className="text-greyFont font-xs font-medium ">{columnData}</div>
                            ) : (
                                <Scorecard color={showGradientTile ? color : undefined} value={columnData} />
                            )}
                        </div>
                    );
                }
            },
        };
        result.push(temp);
    });
    return result;
};

const colorSize = calculateFontSize(window.innerWidth, 13);

export const getScoreCardBrandColumns = (
    data: any,
    selectedAttributeType: any,
    questionObj: any,
    config: any,
    decimalForNonPercentage: number,
    showGradientTile: boolean,
    selectedItem?: string,
) => {
    const { promoScoreCard } = config;
    const labelMapping: any = promoScoreCard.promoTypeLabelMapping;
    const numberFormatDecimal: any[] = promoScoreCard?.question?.numberFormateDecimal || [];
    const decimalIndex = numberFormatDecimal[questionObj?.QuestionIndex] || 0;
    const result: any = [];
    const keysArray = Array.isArray(data) ? Object.keys(data[0]) : [];
    keysArray.slice(0, keysArray.length - 1).map((key, idx) => {
        // console.log(key, 'logging key');
        //excluding color key
        const temp = {
            title: renderTitle(
                idx === 0 ? selectedAttributeType?.label || '' : key,
                idx === 0 ? null : undefined,
                undefined,
                'text-purpleFont !font-medium',
                graphXAxisLabelFontSize,
            ),
            dataIndex: key,
            width: idx <= 1 ? 175 : 110, //make the first 2 columns of 2nd table equal to 1st column of 1st table (for parallel viewing)
            key: key,
            onCell: (record: any, rowIndex: any) => {
                const snakeCasedKey = _.snakeCase(key);
                if (snakeCasedKey in labelMapping && labelMapping[snakeCasedKey]?.label === selectedItem)
                    return {
                        style: {
                            padding: 0,
                            backgroundColor: colorConstants.grey,
                        },
                    };
                return {};
            },
            sorter:
                idx === 0
                    ? false
                    : (a: any, b: any) => {
                          return a[key] - b[key];
                      },
            align: idx === 0 ? 'left' : 'center',
            fixed: idx === 0 ? 'left' : false,

            render: (columnData: any, rowData: any, rowIndex: number) => {
                const className = key === keysArray[0] ? '' : 'flex justify-center gap-2 items-center';
                const color = rowData['color'][key];
                const checkIfColDataExists = columnData !== '' && columnData !== null && columnData !== undefined;
                return (
                    <div
                        className={className}
                        // style={{
                        //     ...categoryImpactedCommonStyles,
                        // }}
                    >
                        {key === keysArray[0] ? (
                            <div className="font-xs">{columnData}</div>
                        ) : (
                            <>
                                <div className="font-xs leading-[normal]">
                                    {checkIfColDataExists
                                        ? idx <= 2
                                            ? formatNumWithKMBAlt(
                                                  columnData,
                                                  decimalForNonPercentage,
                                                  decimalForNonPercentage,
                                              )
                                            : formatNumWithKMBAlt(columnData, decimalIndex, decimalIndex) //show fixed number of decimal places as there in config (this should be equal to the decimal places in first table)
                                        : columnData}{' '}
                                </div>
                                {checkIfColDataExists && showGradientTile && (
                                    <div
                                        style={{
                                            width: colorSize,
                                            height: colorSize,
                                            borderRadius: 2,
                                            background: color,
                                        }}
                                    ></div>
                                )}
                            </>
                        )}
                    </div>
                );
            },
        };
        result.push(temp);
    });
    return result;
};
export const getScoreCardPromoColumns = (data: any) => {
    const result: any = [];
    const keysArray = Object.keys(data[0]);

    keysArray.slice(0, keysArray.length - 1).map((key, idx) => {
        //excluding color key
        const temp = {
            title: renderTitle(
                key,
                idx === 0 ? null : undefined,
                undefined,
                'text-purpleFont !font-medium !text-[15px]',
            ),
            dataIndex: key,
            width: 100,
            key: key,
            align: idx === 0 ? 'left' : 'center',
            fixed: idx === 0 ? 'left' : false,

            render: (columnData: any, rowData: any, rowIndex: number) => {
                const className =
                    key === keysArray[0] || key === keysArray[1] ? '' : 'flex justify-center gap-2 items-center';
                const color = rowData['color'][key];
                const checkIfColDataExists = columnData !== '' && columnData !== null && columnData !== undefined;

                return (
                    <div
                        className={className}
                        // style={{
                        //     ...categoryImpactedCommonStyles,
                        // }}
                    >
                        {key === keysArray[0] || key === keysArray[1] ? (
                            columnData
                        ) : (
                            <>
                                <div>{checkIfColDataExists ? formatNumWithKMBAlt(columnData, 2, 2) : columnData} </div>
                                {checkIfColDataExists && (
                                    <div style={{ width: 8, height: 8, borderRadius: 2, background: color }}></div>
                                )}
                            </>
                        )}
                    </div>
                );
            },
        };
        result.push(temp);
    });
    return result;
};
